import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {I18NextPipe} from 'angular-i18next';
import {ObservableFromSource} from 'app/core/helpers/observable';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export interface FormComponent {
    hasUnsavedData?(): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class UnsavedDataGuard {
    constructor(private i18next: I18NextPipe) {}

    canDeactivate(
        component: FormComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        if (!component || typeof component.hasUnsavedData !== 'function') {
            return true;
        }

        return ObservableFromSource(component.hasUnsavedData()).pipe(
            map(has => {
                if (has) {
                    return window.confirm(this.i18next.transform('common.unsavedDataConfirmation'));
                }
                return true;
            })
        );
    }
}
